/**
 * Created by Rakesh Peela
 * Date: 01-Jan-2020
 * Time: 1:39 PM
 */

export const PUBLISH_FOR_PREVIEW = "PUBLISH_FOR_PREVIEW";
export const PUBLISH_FOR_PREVIEW_PENDING = "PUBLISH_FOR_PREVIEW_PENDING";
export const PUBLISH_FOR_PREVIEW_SUCCESS = "PUBLISH_FOR_PREVIEW_SUCCESS";